const contractStatementPDF = (resp) => {
    if (resp)
        return {
            status: resp.status,
            data: resp.data,
        };
};
export default contractStatementPDF;
